const STORAGE_KEY = "review_session";
const QR_TRACK_KEY = "qr_tracked_tokens";
const SESSION_TTL = 3 * 60 * 60 * 1000; // 3 hours
const QR_TRACK_TTL = 24 * 60 * 60 * 1000; // 24 hours

export const saveSession = (data) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...data, timestamp: Date.now() }));
};

export const getSession = () => {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  const parsed = JSON.parse(raw);
  if (Date.now() - parsed.timestamp > SESSION_TTL) {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }

  return parsed;
};

export const getQrTrackedTokens = () => {
  const raw = localStorage.getItem(QR_TRACK_KEY);
  if (!raw) return {};

  const parsed = JSON.parse(raw);
  const now = Date.now();

  Object.keys(parsed).forEach((t) => {
    if (now - parsed[t] > QR_TRACK_TTL) delete parsed[t];
  });

  localStorage.setItem(QR_TRACK_KEY, JSON.stringify(parsed));
  return parsed;
};

export const markQrTracked = (token) => {
  const tokens = getQrTrackedTokens();
  tokens[token] = Date.now();
  localStorage.setItem(QR_TRACK_KEY, JSON.stringify(tokens));
};

export const saveTokenSession = (token, tokenData) => {
  const session = getSession() || {};
  saveSession({
    ...session,
    tokens: { ...(session.tokens || {}), [token]: tokenData },
  });
};

export const getTokenSession = (token) => {
  const session = getSession();
  return session?.tokens?.[token] || null;
};